import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import toast, { Toaster } from 'react-hot-toast';
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { logIssuanceHistory, getIssuanceRecords, getIssuanceDetail, getWarehouseKeyValueList } from '../../../services/index';
import AddIcon from '@mui/icons-material/Add';
import { Table } from 'react-bootstrap';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { searchForMatch } from '../../utils/textUtils';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';
import { GetFgItemsReports, getSingleFgItem } from '../../../services/Inventory/ItemService';
export const FGItemsView = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const [targetDate, setTargetDate] = useState(date1)
    const navigate = useNavigate()
    const [searchText, setSearchText] = useState("")
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false)
    const { id } = useParams()
    const[targetData,setTargetData]=useState([])

    useEffect(() => {
        getAllRecords();
    }, [targetDate])


    // useEffect(()=>{
    //     getSingleFgItem(id).then((res)=>{
    //         setTargetData(res.responsePacket)
    //     })
    // },[id])


    useEffect(() => {
        if (searchText) {
            let newData = data.filter((e) => e.title.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()))
            setFilteredData(newData);
        }
        else {
            setFilteredData(data)
        }
    }, [searchText])

    const getAllRecords = () => {
        GetFgItemsReports(targetDate).then(((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket.data;
                // d.reverse()
                setFilteredData(d);
                setData(d)
                setLoading(false)
            } else {
                setLoading(false)
                toast(res.message);
            }
        })).catch(error => {
            console.error(error);
            setLoading(false);
        });
    }




    return (
        <>
            <div className='list-column column d-print-none' style={{ width: '300px' }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/salestarget/new" className="newListBtn">
                                <AddIcon />
                                {/* New */}
                            </Link>
                            <div className="input-group searchInput dateInput mr-3">
                                <input
                                    autoComplete="off"
                                    className=" form-control"
                                    type="date"
                                    value={targetDate}
                                    onChange={(e) => setTargetDate(e.target.value)}
                                />
                            </div>
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input value={searchText} onChange={(e) => setSearchText(e.target.value)} autoComplete='off' className='form-control' type='text' placeholder='Search price list' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='scroll-y fill body scrollbox list-body'>
                    <div className='table-responsive overflow-initial'>
                        <table id='ember7912' className='table zi-table table-hover ember-view header-fixed'>
                            {filteredData && (filteredData.length > 0 ?
                                <tbody>
                                    {filteredData.map((row, i) => (
                                        <tr >
                                            <td>
                                                <Link to={`/salestarget/view/${row.uuid}`} className={`${id == row.uuid ? 'text-primary' : 'text-grey'}`}>
                                                    <span className='titleTr'>{row.title}</span>
                                                    <span className='d-flex justify-content-between'>
                                                        <span>{row.selectedDate}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody> : <></>
                            )}

                        </table>
                    </div>
                </div>
            </div>
            <div className='column content-column ' style={{ left: '301px' }}>
                <div className='header no-border d-flex align-items-center p-4'>
                    <h3 className='over-flow header-title'>
                        &nbsp;
                    </h3>
                </div>
                <Tabs className='upperTabs'>
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                    </TabList>
                    <TabPanel>
                        <div className='ember-view scroll-y noscroll-x fill body scrollbox'>
                            <button className="tooltip-container ember-view btn btn-primary print-btn position-absolute" style={{ top: "0px", right: "0px" }}>
                                <LocalPrintshopOutlinedIcon />
                            </button>
                            <br />
                            <div id='scroll'>
                                <div className='font-large text-uppercase font-xs text-open mb-2'></div>
                                <table className='customTable borderedTable'>
                                    <tbody>
                                        <tr>
                                            <td>Target Title:</td>
                                            <td>April Sales Target</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr />

                            <div className='' id='scroll'>
                                <div>
                                    <h3 className='font-size-16'>ISSUED ITEMS</h3>
                                    <table className='customTable borderedTable'>
                                        <thead>
                                            <tr>
                                                <td>S No.</td>
                                                <td>Item</td>
                                                <td>SKU</td>
                                                <td>Quantity</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                </div>
                                <div id='ember3382' className='ember-view'></div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        {/* <div className='ember-view scroll-y noscroll-x fill body scrollbox py-3'>
                                       <table>
                                            {logData.length === 0 ? (
                                                'No Changes Found'
                                            ) : (
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Changes</th>
                                                    </tr>
                                                </thead>
                                            )}
                                            {logData.length >= 1 && (
                                                <tbody>
                                                    {logData?.map((history, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td className='mr-2' style={{ verticalAlign: 'top', width: '100px' }}>
                                                                    {history?.transactionDate?.substring(0, 10)}
                                                                    <br />
                                                                    Time:
                                                                    {history?.transactionDate?.split('T')[1]?.substring(0, 5)}
                                                                </td>
                                                                <td>
                                                                    <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                                 
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            )}
                                       </table>
                                    </div> */}
                    </TabPanel>
                </Tabs>
            </div>
        </>
    )
}

// export default FGItemsView